// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--05981";